// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import axios from "axios"
import { ApiUrls } from '../../utility/ApiUrls'
import GlobalVariable from '../../settings/global'
const paginateArray = (array, perPage, page) => array.slice((page - 1) * perPage, page * perPage)
let getUserCall = false
const baseApiUrl = GlobalVariable.BASE_API_URL
const chunkSize = 1048576 * 7

let count = 0

const getUserApiCall = () => {
  axios.get(`${GlobalVariable.hostpath}api/Common/GetUIConfiguration`)
    .then((res) => {
      const result = res.data
      // callUiConfiguration = false
      if (result) {
        const data = result.data
        if (data) {
          const azureAdB2C = data.azureAdB2C
          const merchantOne = data.merchantOne
          const JsScriptData = data.jsScriptData
          azureAdB2C['apiUrl'] = GlobalVariable.hostpath
          azureAdB2C['hostname'] = window.location.origin
          localStorage.setItem('azureAdB2C', JSON.stringify(azureAdB2C))
          localStorage.setItem('merchantOne', JSON.stringify(merchantOne))
          localStorage.setItem('JsScriptData', JSON.stringify(JsScriptData))
          const expiryTimestamp = new Date().getTime() + (data.expiryTime * 60 * 1000)
          localStorage.setItem('expiryTime', expiryTimestamp)
          const localStorageToken = localStorage.getItem('token')
          axios.get(`${GlobalVariable.hostpath}api/User/GetUser`, {
            headers: { Authorization: `Bearer ${localStorageToken}` }
          }).then((res) => {
            const userData = res.data
            if (userData.success) {
              if (userData.data) {
                if (userData.data.isResetPassword === true) {
                  toast(t => (<ToastMessage t={t} message={"Your password has been changed successfully. Please Login..."} status={"success"} />))
                  setTimeout(() => {
                    localStorage.clear()
                    window.location.reload()
                  }, 3000)
                } else {
                  const cookies = new Cookies()
                  cookies.set('CustomClaims', res.headers["x-set-cookie"], { path: '/' })
                  localStorage.setItem('userData', JSON.stringify(userData.data))
                }
              }
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
              localStorage.clear()
              window.location.reload()
            }
          }).catch((error) => {
            const errorresponse = error.response
            const azureAdB2C = localStorage.getItem('azureAdB2C')
            if (errorresponse) {
              const status = errorresponse.status
              if (status === 403 || status === 401) {
                localStorage.clear()
                window.location.reload()
              } else if (status === 406) {
                window.location.reload()
              } else if (status === 412) {
                const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                localStorage.clear()
                window.location.href = AzureB2CLogoutUrl
              } else if (status === 417 || status === 424) {
                if (count !== 2) {
                  count = count + 1
                }
                if ((count + 1) === 3) {
                  const AzureB2CLogoutUrl = `${azureAdB2C.instance}/${azureAdB2C.domain}/${azureAdB2C.signUpSignInPolicyId}/oauth2/v2.0/logout?post_logout_redirect_uri=${azureAdB2C.hostname}&client_id=${localStorage.getItem('token')}`
                  localStorage.clear()
                  window.location.href = AzureB2CLogoutUrl
                }
              } else {
                toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
                setTimeout(() => {
                  localStorage.clear()
                  window.location.reload()
                }, 2000)
              }
            }
          })
        }
      }
    }).catch((error) => {
      const errorresponse = error.response
      if (errorresponse) {
        const status = errorresponse.status
        if (status === 404) {
          toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
        }
      }
    })
}

const apiCall = async (method, endpoint, data) => {
  const authAxios = DefaultConfig().authAxios
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, data)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const getUpdateFileData = createAsyncThunk("appCommonReducers/getUpdateFileData", async (newObj) => {
  return newObj
})

// Get Employee Dashboard WOrkorders based on pagination
export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      allUsers.push({ userId: element.id, name: element.fullName, email: element.email, companyId: element.companyId, status: element.isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const getOpenFile = createAsyncThunk("appCommonReducers/getOpenFile", async (fileId, thunkAPI) => {
  thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
  const authAxios = DefaultConfig().authAxios
  if (authAxios) {
    const encodedGuid = encodeURIComponent(fileId)
    const returnData = await authAxios.get(`File/PreviewDocument?fileReferenceNumber=${encodedGuid}`)
      .then(async (response) => {
        const resultData = response.data
        if (resultData) {
          if (resultData.success) {
            const respData = resultData.data
            if (respData) {
              if (respData.content) {
                const fileName = respData.fileName
                const contentType = respData.contentType
                const content = respData.content
                if (respData.contentLength) {
                  const totalSize = Number(respData.contentLength)
                  const chunkCount = totalSize % chunkSize === 0 ? totalSize / chunkSize : Math.floor(totalSize / chunkSize) + 1
                  const chunks = []
                  let offset = 0
                  let counter = 1

                  while (offset < totalSize) {
                    const end = Math.min(offset + chunkSize, totalSize) - 1
                    const respayload = await thunkAPI.dispatch(downloadChunk({ offset, end, totalSize, fileId }))
                    const chunk = respayload.payload

                    chunks.push(chunk)
                    offset += chunkSize
                    if (counter === chunkCount) {
                      thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    } else {
                      thunkAPI.dispatch(getUpdateFileData({ counter, total: chunkCount, progress: true, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
                    }
                    counter++
                  }

                  if ((fileName.includes('.pdf') || fileName.includes('.PDF'))) {
                    //
                  } else {
                    const blobChunks = []
                    // Fetch each chunk and push it to the array
                    for (const chunk of chunks) {
                      const response = await fetch(`data:application/octet-stream;base64,${chunk}`)
                      const blob = await response.blob()
                      blobChunks.push(blob)
                    }

                    // Convert the Uint8Array to a Blob
                    const concatenatedBlob = new Blob(blobChunks, { type: contentType })
                    // Generate download URL
                    const downloadUrl = URL.createObjectURL(concatenatedBlob)
                    // Initiate a download by creating an anchor element and programmatically clicking it
                    const link = document.createElement('a')
                    link.href = downloadUrl
                    link.download = fileName
                    link.style.display = 'none'
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    URL.revokeObjectURL(downloadUrl)
                  }
                }

                return {
                  data: { fileName, contentType, fileContent: '', chunks: [content], fileName, message: '' },
                  tokenExp: false
                }
              } else {
                return {
                  data: { chunks: [], message: respData?.errorMessage },
                  tokenExp: false
                }
              }
            } else {
              return {
                data: { chunks: [], message: resultData?.errorMessage },
                tokenExp: false
              }
            }
          } else {
            if (resultData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={resultData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: 1, totalfilecount: [1], fileStatus: 'Downloading' }))
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            // const error = errorresponse.data.error
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
    return returnData
  } else {
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
  }
})

export const DownloadFile = createAsyncThunk("appCommonReducers/DownloadFile", async (id, thunkAPI) => {
  const authAxios = DefaultConfig().authAxios

  if (!authAxios) {
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    return
  }

  try {
    const response = await authAxios.get(`Files/PreviewFile?fileId=${id}`, {
      responseType: 'blob' // 👈 This is CRUCIAL
    })


    return {
      data: response.data, // 👈 This is the actual PDF Blob
      contentType: response.headers['content-type'],
      fileName: response.headers['content-disposition']?.split('filename=')[1]?.replace(/["']/g, '')
    }
  } catch (error) {
    const errorresponse = error.response
    const status = errorresponse?.status

    if (status === 403) return ''
    if (status === 406) toast(t => (<ToastMessage t={t} message={"Unauthorized"} status={"danger"} />))
    else if (status === 419 && !getUserCall) {
      getUserCall = true
      toast(t => (<ToastMessage t={t} message={"Cookie expired"} status={"danger"} />))
    } else if (status === 401) {
      localStorage.clear()
      window.location.reload()
    } else {
      toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }

    return ''
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const getFileData = createAsyncThunk("appCommonReducers/getFileData", async (wdata) => {
  return wdata
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUsersDetailsByEmail = createAsyncThunk("appCommonReducers/GetUsersDetailsByEmail", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetUsersDetailsByEmail}`
  const data = rdata.obj
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

// Get Employee Dashboard WOrkorders based on pagination
export const getWorkordersByFilters = createAsyncThunk("appCommonReducers/getWorkordersByFilters", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetVessels
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.vessels ? resultData.vessels : []
    const recCount = resultData.count
    const gridSize = obj.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetArrivals = createAsyncThunk("appCommonReducers/GetArrivals", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetArrivals
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.vessels ? resultData.vessels : []
    const recCount = resultData.count
    const gridSize = obj.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUpcomingFSInspections = createAsyncThunk("appCommonReducers/GetUpcomingFSInspections", async (obj) => {
  const method = 'post'
  const endpoint = ApiUrls.GetUpcomingFSInspections
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    const workordersDto = resultData.fS_Inspections ? resultData.fS_Inspections : []
    const recCount = resultData.count
    const gridSize = obj.pageSize
    return {
      data: workordersDto,
      recCount,
      gridSize,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetVesselInspections = createAsyncThunk("appCommonReducers/GetVesselInspections", async (obj) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetVesselInspections}`
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return resultData
  }
})

export const GetInspectionDetentionStatistics = createAsyncThunk("appCommonReducers/GetInspectionDetentionStatistics", async (obj) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInspectionDetentionStatistics}`
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return resultData
  }
})
// https://localhost:44462/api/Vessels/GetVesselStatistics
export const GetVesselStatistics = createAsyncThunk("appCommonReducers/GetVesselStatistics", async (obj) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetVesselStatistics}`
  const data = obj
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return resultData
  }
})

// Get Company Details in salesforce
export const GetCompanyDetailsByName = createAsyncThunk("appCommonReducers/GetCompanyDetailsByName", async (name) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCompanyDetailsByName}?companyName=${name}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  return resultData
})

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

export const GetAllFiles = createAsyncThunk("appCommonReducers/GetAllFiles", async (obj) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetAllFiles}`
  const payload = obj.payload
  const wdata = obj.payload
  const resultData = await apiCall(method, endpoint, payload)
  if (resultData) {

    const files = resultData.files
    return {
      data: files,
      perPage: wdata.pageSize,
      totalCount: resultData.totalCount,
      page: wdata.pageIndex,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const getWoLoading = createAsyncThunk("appCommonReducers/getWoLoading", async () => {
  return ''
})

export const getDataFileData = createAsyncThunk("appCommonReducers/getDataFileData", async (data) => {
  return data
})

export const uploadCompleted = createAsyncThunk("appCommonReducers/uploadCompleted", async ({ blocksData, values }, thunkAPI) => {
  try {
    const authAxios = axios.create({
      baseURL: baseApiUrl,
      headers: {
        "X-File-Name": values['filename'],
        "X-FilereferenceId": values['guid'],
        "X-DocumentType": values.fileDto[0].documentType,
        "X-DocumentSubType": values.fileDto[0].documentSubType,
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      withCredentials: true
    })

    const payloadToSent = { BlockIds: blocksData, FileReference: values?.guid, FileName: values?.filename, CustomLookup1: values?.CustomLookup1, CustomLookup2: values?.CustomLookup2, Category: values?.category ?? 1 }
    const response = await authAxios.post(`Files/CompleteUpload`, payloadToSent)
    const resData = response.data
    if (resData.success) {
      const newObj = {}
      newObj['floader'] = true
      newObj['tokenExp'] = false
      newObj['fileData'] = resData.data

      newObj['beginingOfTheChunk'] = 0
      newObj['endOfTheChunk'] = chunkSize
      newObj['blockData'] = []
      return newObj
    } else {
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
    }
  } catch (error) {
    thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
    toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
  }
})


// export const FileUploadChunks = createAsyncThunk("appCommonReducers/FileUploadChunks", async (values, thunkAPI) => {
//   if (values.fileDto.length > 0) {
//     const chunk = values['_file'].slice(values.beginingOfTheChunk, values.endOfTheChunk)
//     // const formData = new FormData()
//     // formData.append('file', values['_file'])
//     try {
//       const authAxios = axios.create({
//         baseURL: baseApiUrl,
//         headers: {
//           "X-Total-Chunks": values['chunkCount'],
//           "X-Chunk-Number": values['counter'],
//           "X-File-Name": (values['filename']),
//           "X-File-Size": values['fileSize'],
//           "X-Chunk-Size": values['chunkSize'],
//           "X-DocumentType": values.fileDto[0].documentType,
//           // "X-DocumentSubType": values.fileDto[0].documentSubType,
//           // "X-WoId": values.fileDto[0].woId,
//           // "X-AgentId": values.fileDto[0].agentId,
//           // "X-CustomLookUpID1": values.fileDto[0].customLookUpID1,
//           // "X-CustomLookUpID2": values.fileDto[0].customLookUpID2,
//           // "X-IsExternal": values.fileDto[0].isExternal,
//           "X-FilereferenceId": values['guid'],
//           // "Content-Type": "multipart/form-data",
//           "Content-Type": "application/octet-stream",
//           Authorization: `Bearer ${localStorage.getItem('token')}`
//         },
//         withCredentials: true
//       })

//       const response = await authAxios.post(`Files/FileUploadChunk?category=1&fileReference=${values['guid']}&fileName=${values['filename']}&overwrite=true`, chunk)
//       const respdata = response.data
//       if (respdata.success) {
//         if (respdata.errorMessage) {
//           thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//           toast(t => (<ToastMessage t={t} message={respdata.errorMessage} status={"danger"} />))
//           return ''
//         } else {

//           if (values['counter'] === values['chunkCount']) {
//             const blocksData = values.blockData
//             blocksData.push(respdata.data.blockId)
//             if (respdata.data?.blockId) {
//               const respayload = await thunkAPI.dispatch(uploadCompleted({ blocksData, values }))
//               const uploadedData = respayload.payload
//               return uploadedData
//             } else {
//               const newObj = {}
//               const fileData = respdata.data
//               fileData['doumentType'] = values.fileDto[0].documentType
//               newObj['floader'] = true
//               newObj['tokenExp'] = false
//               newObj['fileData'] = fileData
//               newObj['woType'] = values.fileDto[0].type
//               newObj['woTypeId'] = values.woId
//               newObj['stype'] = values.stype

//               newObj['beginingOfTheChunk'] = 0
//               newObj['endOfTheChunk'] = values['chunkSize']
//               newObj['blockData'] = []
//               return newObj
//             }
//           } else {
//             const blocksData = values.blockData
//             blocksData.push(respdata.data.blockId)
//             const beginingOfTheChunk = values['endOfTheChunk']
//             const endOfTheChunk = values['endOfTheChunk'] + values['chunkSize']
//             const newObj = {}
//             newObj['beginingOfTheChunk'] = beginingOfTheChunk
//             newObj['endOfTheChunk'] = endOfTheChunk
//             newObj['blockData'] = blocksData
//             return newObj
//           }
//         }
//       } else {
//         thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//         toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
//         return ''
//       }
//     } catch (error) {
//       thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
//       toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
//       return ''
//     }
//   }
// })

export const FileUploadChunks = createAsyncThunk("appCommonReducers/FileUploadChunks", async (values, thunkAPI) => {
  if (values.fileDto.length > 0) {
    const chunk = values['_file'].slice(values.beginingOfTheChunk, values.endOfTheChunk)

    try {
      const authAxios = axios.create({
        baseURL: baseApiUrl,
        headers: {
          "X-Total-Chunks": values['chunkCount'],
          "X-Chunk-Number": values['counter'],
          "X-File-Name": values['filename'],
          "X-File-Size": values['fileSize'],
          "X-Chunk-Size": values['chunkSize'],
          "X-DocumentType": values.fileDto[0].documentType,
          "X-FilereferenceId": values['guid'],
          "Content-Type": "application/octet-stream",
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        withCredentials: true
      })

      const response = await authAxios.post(
        `Files/FileUploadChunk?category=1&fileReference=${values['guid']}&fileName=${values['filename']}&overwrite=true`,
        chunk
      )

      const respdata = response.data

      if (respdata.success) {
        if (respdata.errorMessage) {
          thunkAPI.dispatch(getUpdateFileData({
            counter: 0,
            total: 0,
            progress: false,
            fileCount: values['fileCount'] ?? 1,
            totalfilecount: values['totalfilecount'] ?? [1],
            fileStatus: 'Uploading'
          }))
          toast(t => (<ToastMessage t={t} message={respdata.errorMessage} status="danger" />))
          return ''
        } else {
          const blocksData = values.blockData
          blocksData.push(respdata.data.blockId)

          if (values['counter'] === values['chunkCount']) {
            if (respdata.data?.blockId) {
              const respayload = await thunkAPI.dispatch(uploadCompleted({ blocksData, values }))
              return respayload.payload
            } else {
              const fileData = respdata.data
              const newObj = {
                floader: true,
                tokenExp: false,
                fileData,
                woType: values.fileDto[0].type,
                woTypeId: values.woId,
                stype: values.stype,
                beginingOfTheChunk: 0,
                endOfTheChunk: values['chunkSize'],
                blockData: []
              }
              fileData['doumentType'] = values.fileDto[0].documentType
              return newObj
            }
          } else {
            const beginingOfTheChunk = values['endOfTheChunk']
            const endOfTheChunk = values['endOfTheChunk'] + values['chunkSize']
            return {
              beginingOfTheChunk,
              endOfTheChunk,
              blockData: blocksData
            }
          }
        }
      } else {
        thunkAPI.dispatch(getUpdateFileData({
          counter: 0,
          total: 0,
          progress: false,
          fileCount: values['fileCount'] ?? 1,
          totalfilecount: values['totalfilecount'] ?? [1],
          fileStatus: 'Uploading'
        }))
        toast(t => (<ToastMessage t={t} message="Something Went Wrong..." status="danger" />))
        return ''
      }
    } catch (error) {
      const errorResponse = error.response

      if (errorResponse) {
        const status = errorResponse.status
        if (status === 403) {
          return ''
        } else if (status === 406) {
          toast(t => (<ToastMessage t={t} message="Unauthorized" status="danger" />))
          return ''
        } else if (status === 419) {
          if (!getUserCall) {
            getUserCall = true
            toast(t => (<ToastMessage t={t} message="Cookie expired" status="danger" />))
            return ''
          }
        } else if (status === 401) {
          localStorage.clear()
          window.location.reload()
        } else {
          toast(t => (<ToastMessage t={t} message="Something Went Wrong..." status="danger" />))
          return ''
        }
      }

      thunkAPI.dispatch(getUpdateFileData({
        counter: 0,
        total: 0,
        progress: false,
        fileCount: values['fileCount'] ?? 1,
        totalfilecount: values['totalfilecount'] ?? [1],
        fileStatus: 'Uploading'
      }))
      toast(t => (<ToastMessage t={t} message="Something Went Wrong..." status="danger" />))
      return ''
    }
  }
})

export const getRefreshToken = createAsyncThunk("appCommonReducers/getRefreshToken", async () => {
  const method = 'get'
  const endpoint = `User/GetRefreshToken`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    localStorage.setItem("token", resultData.id_token)
    localStorage.setItem("refresh_token", resultData.refresh_token)
    getUserApiCall()
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: null,
      spinner: true,
      tokenExp: false
    }
  }
})

export const saveFileUploads = createAsyncThunk("appCommonReducers/saveFileUploads", async (values, thunkAPI) => {

  if (values.fileDto.length > 0) {
    const _file = values.fileDto[0].file
    if (_file.size > 0 && _file.size <= 1048576 * 1024) {
      const chunkCount = _file.size % chunkSize === 0 ? _file.size / chunkSize : Math.floor(_file.size / chunkSize) + 1
      thunkAPI.dispatch(getUpdateFileData({ counter: 0, total: 0, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
      const fileSize = _file.size

      let filename = ''
      if (values?.newList) {

        const newList = values?.newList
        const newFileName = _file.name

        const nameParts = newFileName.split('.') // Split filename and extension
        const baseName = nameParts.slice(0, -1).join('.') // Filename without extension
        const extension = nameParts.length > 1 ? `.${nameParts[nameParts.length - 1]}` : '' // Extension with the dot

        let counter = 0
        let fileExists = true
        let finalFileName = newFileName

        const getBaseName = (fileName) => {
          return fileName.split('.').slice(0, -1).join('.')
        }

        const fileExistsInArray = (filename) => {
          const extension = filename.split('.').pop()
          const baseName = filename.replace(`.${extension}`, '')
          return newList.some(file => getBaseName(file.fileName) === baseName)
        }

        while (fileExists) {
          if (counter === 0) {
            finalFileName = `${baseName}${extension}` // Original filename on the first iteration
          } else {
            finalFileName = `${baseName}_${counter}${extension}` // Append the counter before the extension
          }

          if (!fileExistsInArray(finalFileName)) {
            fileExists = false // Exit the loop when a unique filename is found
          } else {
            counter++ // Increment counter if the file exists
          }
        }

        filename = finalFileName
      } else {
        filename = _file.name
      }

      values['chunkSize'] = chunkSize
      values['_file'] = _file
      values['chunkCount'] = chunkCount
      values['fileSize'] = fileSize
      values['filename'] = (filename)

      function generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (Math.random() * 16) | 0
          const v = c === 'x' ? r : (r & 0x3) | 0x8
          return v.toString(16)
        })
      }

      values['guid'] = generateGUID()

      values['beginingOfTheChunk'] = 0
      values['endOfTheChunk'] = chunkSize
      values['blockData'] = []

      for (let i = 0; i < chunkCount; i++) {
        values['counter'] = i + 1
        const respayload = await thunkAPI.dispatch(FileUploadChunks(values))
        const fileUploadData = respayload.payload
        if ((i + 1) === chunkCount) {
          if (fileUploadData) {
            thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: false, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            return {
              data: fileUploadData.fileData,
              spinner: fileUploadData.floader,
              tokenExp: fileUploadData.tokenExp,
              woType: fileUploadData.woType,
              woTypeId: fileUploadData.woTypeId,
              stype: fileUploadData.stype,
              type: values['type']
            }
          } else {
            break
          }
        } else {
          if (fileUploadData) {
            thunkAPI.dispatch(getUpdateFileData({ counter: values['counter'], total: chunkCount, progress: true, fileCount: values['fileCount'] ? values['fileCount'] : 1, totalfilecount: values['totalfilecount'] ? values['totalfilecount'] : [1], fileStatus: 'Uploading' }))
            values['beginingOfTheChunk'] = fileUploadData.beginingOfTheChunk
            values['endOfTheChunk'] = fileUploadData.endOfTheChunk
            values['blockData'] = fileUploadData.blockData
          } else {
            break
          }
        }
      }
    } else {
      if (_file.size <= 0) {
        toast(t => (<ToastMessage t={t} message={"Please upload file more than 0 KB"} status={"danger"} />))
      } else {
        toast(t => (<ToastMessage t={t} message={"FIle upload does not exceed more than 1 GB"} status={"danger"} />))
      }
    }
  }
})
export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    usersData: null,
    uspiner: false,
    usersData: null,
    uspiner: false,
    userRoleData: [],
    urspiner: false,

    adtspiner: false,
    deptData: [],
    adsspiner: true,
    docTypeData: [],
    docSubTypeData: [],
    dtdspiner: false,
    docTypeDepData: [],
    redirectFileData: [],

    pSpinner: false,
    pallData: [],
    phallData: [],
    pdata: [],
    ptotalCount: 1,
    pperPage: 0,
    ppage: 1,

    fileData: {},
    floader: true,

    mfileData: {},
    mloader: true,
    total: 0,
    counter: 0,
    progress: false,
    fileCount: 0,
    totalfilecount: [],

    fileStatus: '',
    fileExceed: false,
    chunksData: [],
    dmenuData: [],
    woData: [],
    spinner3: false,
    recCount: 0,
    gridSize: 0
  },
  reducers: {},
  extraReducers: builder => {
    builder
      // start role management
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })

      .addCase(getWorkordersByFilters.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      }).addCase(GetArrivals.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      }).addCase(GetUpcomingFSInspections.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner3 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.woData = action.payload.data
          state.recCount = action.payload.recCount
          state.gridSize = action.payload.gridSize
        }
      })
      .addCase(getOpenFile.fulfilled, (state, action) => {
        if (action.payload?.data) {
          state.chunksData = action.payload.data.chunks
        }
      })
      .addCase(GetAllFiles.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const perPage = action.payload.perPage
          const page = action.payload.page
          // const fileReference = action.payload.fileReference
          // const docTypeValue = action.payload.docTypeValue
          // const docSubTypeValue = action.payload.docSubTypeValue
          // const email = action.payload.email
          // const docTypes = state.docTypeData
          // const docSubTypes = state.docSubTypeData
          // const departments = state.deptData

          const arrayOfObjectsWithDates = action.payload.data
          // for (let i = 0; i < arrayOfObjectsWithDates.length; i++) {
          //   const data = arrayOfObjectsWithDates[i]
          //   const findDocType = docTypes.find(find => find.value === data.documentTypeId)
          //   const findDocSubType = docSubTypes.find(find => find.value === data.documentSubTypeId)
          //   const findDep = departments.find(find => find.value === data.departmentId)
          //   data['documentType'] = findDocType ? findDocType.label : ''
          //   data['documentSubType'] = findDocSubType ? findDocSubType.label : ''
          //   data['department'] = findDep ? findDep.label : ''
          // }
          state.pallData = arrayOfObjectsWithDates
          state.phallData = arrayOfObjectsWithDates

          // if (fileReference) {
          //   state.phallData = state.phallData.filter(find => ((find.fileReference && String(find.fileReference).toLowerCase().includes(fileReference.toLowerCase()))))
          // }
          // if (docTypeValue) {
          //   state.phallData = state.phallData.filter(find => find.documentTypeId === docTypeValue)
          // }
          // if (docSubTypeValue) {
          //   state.phallData = state.phallData.filter(find => find.documentTypeId === docSubTypeValue)
          // }
          // if (email) {
          //   state.phallData = state.phallData.filter(find => ((find.userEmail && String(find.userEmail).toLowerCase().includes(email.toLowerCase()))))
          // }
          state.phallData = state.phallData
          //  state.pdata = paginateArray(state.phallData, perPage, page)
          state.pdata = state.phallData
          state.pperPage = perPage
          state.ppage = page
          state.ptotalCount = action.payload.totalCount
          state.pSpinner = action.payload.spinner
        }
      })
      .addCase(getFileData.fulfilled, (state, action) => {
        const perPage = action.payload.PageSize
        const page = action.payload.PageNumber
        const sortname = action.payload.sortname
        const sortorder = action.payload.sortorder
        const fileReference = action.payload.fileReference
        const woId = action.payload.woId
        const agentId = action.payload.agentId
        const docTypeValue = action.payload.docTypeValue
        const docSubTypeValue = action.payload.docSubTypeValue
        const customLookUpID1 = action.payload.customLookUpID1
        const customLookUpID2 = action.payload.customLookUpID2
        const deptValue = action.payload.deptValue

        const email = action.payload.email
        state.phallData = JSON.parse(JSON.stringify(state.pallData))
        if (deptValue) {
          state.phallData = state.phallData.filter(find => find.departmentId === deptValue)
        }
        if (fileReference) {
          state.phallData = state.phallData.filter(find => ((find.fileReference && String(find.fileReference).toLowerCase().includes(fileReference.toLowerCase()))))
        }
        if (docTypeValue) {
          state.phallData = state.phallData.filter(find => find.documentTypeId === docTypeValue)
        }
        if (docSubTypeValue) {
          state.phallData = state.phallData.filter(find => find.documentSubTypeId === docSubTypeValue)
        }
        if (customLookUpID1) {
          state.phallData = state.phallData.filter(find => find.customLookUpID1 === customLookUpID1)
        }
        if (customLookUpID2) {
          state.phallData = state.phallData.filter(find => find.customLookUpID2 === customLookUpID2)
        }
        if (woId) {
          state.phallData = state.phallData.filter(find => find.woId === woId)
        }
        if (agentId) {
          state.phallData = state.phallData.filter(find => find.agentId === agentId)
        }
        if (email) {
          state.phallData = state.phallData.filter(find => ((find.userEmail && String(find.userEmail).toLowerCase().includes(email.toLowerCase()))))
        }
        const sortData = sortorder ? sorter(sortname, sortorder, state.phallData) : state.phallData
        state.pdata = paginateArray(sortData, perPage, page)
        state.ptotalCount = sortData.length
        state.pperPage = perPage
        state.ppage = page
      })
      .addCase(getWoLoading.fulfilled, (state) => {
        state.spinner3 = false
      })
      .addCase(getDataFileData.fulfilled, (state, action) => {
        state.redirectFileData = []
        state.redirectFileData = action.payload
      })
      .addCase(getUpdateFileData.fulfilled, (state, action) => {
        if (action.payload) {
          state.total = action.payload.total
          state.counter = action.payload.counter
          state.progress = action.payload.progress
          state.fileCount = action.payload.fileCount
          state.totalfilecount = action.payload.totalfilecount
          state.fileStatus = action.payload.fileStatus
        }
      })
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
    // end role management
  }
})
export const { handleAddtoCart } = commonreducerSlice.actions
export default commonreducerSlice.reducer
